import React from 'react';
import { IconProps } from '.';

const SvgArrowDecrease = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} fillRule='evenodd' d='m12 22 8-12.5h-5.333V2H9.333v7.5H4L12 22Z' clipRule='evenodd' />
    </svg>
  );
};

export default SvgArrowDecrease;
